// ----------------------------------------------------------------------

const account = {
  displayName: 'Voltaic User',
  email: 'Voltaic LLC',
  photoURL: '/assets/images/avatars/avatar_default.jpg'
};

export default account;
